import { Controller as BaseController } from 'stimulus'
import { useDebounce } from 'stimulus-use'
import Rails from '@rails/ujs'
import ordinal from 'ordinal'

export class Controller extends BaseController {
  static debounces = ['validateEmail']
  static targets = [
    'saveButton',
    'errorMessage',
    'recipientEmails',
    'repeatsEverySelect',
    'emailValidationMessage',
    'repeatsEveryWeekContent',
    'repeatsEveryMonthContent',
    'startDateInput',
    'repeatsEveryInput',
    'onInput',
    'endDateComponent'
  ]

  static values = {}

  connect() {
    this.saveButtonTarget.disabled = true
    this.defaultEndDate = this.endDateComponentTarget.querySelector('#end-date-test-id').getAttribute('value')
    useDebounce(this, { wait: 500 })

    Promise.resolve().then(() => { this.afterConnect() })
  }

  afterConnect() {
    this.updateRepeatsEveryContent()
    this.updateEndDate()
    this.updateMonthlyMsg()

    this.validateEmail()
  }

  updateEndDate() {
    const datetimeInput = this.endDateComponentTarget['atomic--atom--input--datetime--component']

    this.onInputTarget.checked ? datetimeInput.setDate(this.defaultEndDate) : datetimeInput.clearDate()
  }

  updateMonthlyMsg(event) {
    const selectValue = this.repeatsEverySelectTarget.value
    if (selectValue === 'month') {
      const msg = this.monthlyMsg()
      if (typeof msg !== 'string') { console.log('isUndefined'); return }
      this.repeatsEveryMonthContentTarget.innerHTML = `${msg}`
    }
  }

  monthlyMsg() {
    const amount = parseInt(this.repeatsEveryInputTarget.value)

    if (Number.isNaN(amount)) {
      console.error('Invalid repeats every input value')
      return ''
    }

    if (amount < 1) { return '' };

    const dateTime = new Date(`${this.startDateInputTarget.value} 00:00`)
    if (dateTime.toString() === 'Invalid Date') {
      console.error('invalid format of date for start_date input value', this.startDateInputTarget.value)
      return ''
    }

    const isLastDay = (dateTime) => {
      const test = new Date(dateTime.getTime())
      const month = test.getMonth()
      test.setDate(test.getDate() + 1)
      return test.getMonth() !== month
    }

    let repeatsOnMsg
    const dateTimeDay = dateTime.getDate()
    const countsAsLastDayOfMonth = [30, 31].includes(dateTimeDay)
    if (countsAsLastDayOfMonth || isLastDay(dateTime)) {
      const prefix = countsAsLastDayOfMonth ? `${ordinal(dateTimeDay)} or ` : ''
      repeatsOnMsg = `${prefix}the last day of the month`
    } else {
      repeatsOnMsg = `the ${ordinal(dateTimeDay)}`
    }

    let repeatsEveryMonthMsg
    if (amount === 1) {
      repeatsEveryMonthMsg = 'month'
    } else {
      repeatsEveryMonthMsg = `${amount} months`
    }

    return `Repeats every ${repeatsEveryMonthMsg} on ${repeatsOnMsg} `
  }

  validateEmail(event) {
    Rails.ajax({
      type: 'post',
      dataType: 'script',
      url: '/email_recipients/validate',
      data: $.param({
        email_addresses: this.recipientEmailsTarget.value
      }),
      success: (response) => {
        this.errorMessageTarget.classList.remove('block')
        this.errorMessageTarget.classList.add('hidden')
        this.saveButtonTarget.disabled = false
        this.emailValidationMessageTarget.innerHTML = null
      },
      error: (errors) => {
        this.saveButtonTarget.disabled = true

        this.errorMessageTarget.classList.remove('hidden')
        this.errorMessageTarget.classList.add('block')

        this.emailValidationMessageTarget.innerHTML = null
        this.emailValidationMessageTarget.classList.add('ml-8', 'mt-2', 'text-red', 'font-mono')

        const errorText = document.createElement('li')
        errorText.innerText = 'Invalid email addresses:'
        errorText.classList.add('list-none', 'mb-2')
        this.emailValidationMessageTarget.append(errorText)

        $.each(errors, (key, value) => {
          const error = document.createElement('li')
          error.innerText = value
          error.classList.add('ml-5')
          this.emailValidationMessageTarget.append(error)
        })
      }
    })
  }

  updateRepeatsEveryContent(event) {
    const selectValue = this.repeatsEverySelectTarget.value

    if (selectValue === 'week') {
      this.showContentAndInputs(this.repeatsEveryWeekContentTarget)
      this.hideContentAndInputs(this.repeatsEveryMonthContentTarget)
    } else if (selectValue === 'month') {
      this.showContentAndInputs(this.repeatsEveryMonthContentTarget)
      this.hideContentAndInputs(this.repeatsEveryWeekContentTarget)
    }
  }

  hideContentAndInputs(content) {
    content.setAttribute('hidden', 'hidden')
    const inputs = content.querySelector('input')
    if (inputs && inputs.length > 0) {
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].setAttribute('disabled', 'disabled')
      }
    }
  }

  showContentAndInputs(content) {
    content.removeAttribute('hidden')
    const inputs = content.querySelector('input')
    if (inputs && inputs.lenght > 0) {
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].removeAttribute('disabled')
      }
    }
  }
}
